import axios from 'axios';
import React from 'react';

const CONTENTS_BASE_URL = 'https://cdn.contents.io';
const CONTENTS_TEAM = 'skip';
const CONTENTS_COLLECTION = 'ranger-training';
const CONTENTS_ITEM = 'ranger-training';
const CONTENTS_URL = `${CONTENTS_BASE_URL}/teams/${CONTENTS_TEAM}/collections/${CONTENTS_COLLECTION}/items/${CONTENTS_ITEM}`;


class RangerTraining extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      trainingBody: null
    }
  }

  componentDidMount = async () => {
    const {data} = await axios.get(CONTENTS_URL);
    const {body} = data.properties;

    this.setState({
      isLoading: false,
      trainingBody: body,
    })
  }

  render() {
    const {trainingBody, isLoading} = this.state;

    if (isLoading) {
      return <div>Loading training...</div>
    }

    return (
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <div dangerouslySetInnerHTML={{__html: trainingBody}} />
          </div>
        </div>
      </div>
    );
  }
}

RangerTraining.propTypes = {

};

export {RangerTraining};


// WEBPACK FOOTER //
// ./src/street-team/RangerTraining.js